import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-0 bg-white lead-info-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 pt-lg-30 pb-lg-30 ps-lg-25 pe-lg-25" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "align-items-center d-flex flex-wrap gap-3 mb-10" }
const _hoisted_5 = { class: "survey-ranges align-items-center d-flex flex-grow-1 gap-3 justify-content-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-caret-left" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "fw-bold text-black text-center flex-grow-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-caret-right" }, null, -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "form-group ms-auto" }
const _hoisted_12 = ["disabled", "value"]
const _hoisted_13 = { value: "month" }
const _hoisted_14 = { value: "year" }
const _hoisted_15 = {
  key: 0,
  class: "text-paragraph mb-0"
}
const _hoisted_16 = {
  key: 2,
  class: "d-flex justify-content-center mt-15"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "d-flex justify-content-center mt-15"
}
const _hoisted_19 = { class: "d-flex justify-content-between align-items-end flex-wrap gap-3" }
const _hoisted_20 = { class: "mt-10" }
const _hoisted_21 = { class: "d-flex justify-content-end align-items-center gap-3 mb-25 mt-15" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { value: "table" }
const _hoisted_25 = { value: "list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_SurveyTable = _resolveComponent("SurveyTable")!
  const _component_SurveyResponses = _resolveComponent("SurveyResponses")!
  const _component_SurveyStatsChartWithRole = _resolveComponent("SurveyStatsChartWithRole")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.survey.description && _ctx.show_description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.survey.description), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("nav", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
          }, [..._hoisted_7]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.range_select_header), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
          }, [..._hoisted_10])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("select", {
            class: "form-select shadow-none text-black p-10 pe-50 bg-body-tertiary fs-14 border-0 w-auto ms-auto",
            disabled: _ctx.loading,
            required: "",
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateRange && _ctx.updateRange(...args))),
            value: _ctx.range_type
          }, [
            _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t("feature.therapy.$trend_range.$frequency.month")), 1 /* TEXT */),
            _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t("feature.therapy.$trend_range.$frequency.year")), 1 /* TEXT */)
          ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_12)
        ])
      ]),
      (_ctx.responses === undefined)
        ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
            key: 1,
            class: "h-auto"
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.responses?.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t('feature.surveys.no_surveys')), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.env === 'sifi_fk' || _ctx.env === 'fungalk')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.survey.key === 'gold-standard')
                          ? (_openBlock(), _createBlock(_component_SurveyTable, {
                              key: 0,
                              survey: _ctx.survey,
                              responses: _ctx.responses
                            }, null, 8 /* PROPS */, ["survey", "responses"]))
                          : (_openBlock(), _createBlock(_component_SurveyResponses, {
                              key: 1,
                              survey: _ctx.survey,
                              responses: _ctx.responses
                            }, null, 8 /* PROPS */, ["survey", "responses"])),
                        _createCommentVNode(" LOADING "),
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(_component_SpinnerLoading, { class: "h-auto" })
                            ]))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_ctx.env === 'kareena')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createCommentVNode(" CHART "),
                          _createVNode(_component_SurveyStatsChartWithRole, {
                            survey: _ctx.survey,
                            responses: _ctx.responses
                          }, null, 8 /* PROPS */, ["survey", "responses"]),
                          _createCommentVNode(" DATAS "),
                          (_ctx.responses !== undefined && _ctx.responses.length !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createCommentVNode(" LOADING "),
                                (_ctx.loading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                      _createVNode(_component_SpinnerLoading, { class: "h-auto" })
                                    ]))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createCommentVNode(" SHOW DATA "),
                                      _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, [
                                          (_ctx.show_detail === false)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                type: "button",
                                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args))),
                                                class: "ms-auto card-link-btn border-0 bg-transparent p-0 text-decoration-none text-primary fw-medium position-relative d-inline-block"
                                              }, _toDisplayString(_ctx.$t("cta.view_data")), 1 /* TEXT */))
                                            : (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                type: "button",
                                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.show_detail = false)),
                                                class: "ms-auto card-link-btn border-0 bg-transparent p-0 text-decoration-none text-primary fw-medium position-relative d-inline-block"
                                              }, _toDisplayString(_ctx.$t("cta.hide_data")), 1 /* TEXT */))
                                        ])
                                      ])
                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                                (_ctx.show_detail == true)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("div", _hoisted_22, [
                                          _withDirectives(_createElementVNode("select", {
                                            class: "form-select shadow-none text-black p-15 pe-50 bg-body-tertiary fs-14 border-0",
                                            disabled: _ctx.loading,
                                            required: "",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.data_typology) = $event))
                                          }, [
                                            _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.$t("feature.surveys.typology.table")), 1 /* TEXT */),
                                            _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.$t("feature.surveys.typology.list")), 1 /* TEXT */)
                                          ], 8 /* PROPS */, _hoisted_23), [
                                            [_vModelSelect, _ctx.data_typology]
                                          ])
                                        ])
                                      ]),
                                      (_ctx.data_typology === 'table')
                                        ? (_openBlock(), _createBlock(_component_SurveyTable, {
                                            key: 0,
                                            survey: _ctx.survey,
                                            responses: _ctx.responses
                                          }, null, 8 /* PROPS */, ["survey", "responses"]))
                                        : (_ctx.data_typology === 'list')
                                          ? (_openBlock(), _createBlock(_component_SurveyResponses, {
                                              key: 1,
                                              survey: _ctx.survey,
                                              responses: _ctx.responses
                                            }, null, 8 /* PROPS */, ["survey", "responses"]))
                                          : _createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
    ])
  ]))
}